module.exports = __webpack_public_path__ + "img/devices.b4f2f995.svg";